import axios from "../../config/axiosConfig";
import { CREATE_ACCOUNT, GET_ACCOUNT, ACCOUNT_REQUEST, DELETE_ACCOUNT, UPDATE_ACCOUNT, ACCOUNT_REQUEST_FAILURE, GET_ACCOUNTS_PAGE,
  ACCOUNT_REQUEST_SUCCESS, UPDATE_ACCOUNT_IN_LIST, UPDATE_ACCOUNT_IN_MASTER_OPTIONS, ADD_ACCOUNT_IN_LIST, ADD_ACCOUNT_IN_MASTER_OPTIONS,
  DELETE_ACCOUNT_IN_MASTER_OPTIONS, DELETE_ACCOUNT_IN_LIST } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getAccountsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, commonMaster) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Sech_Id,Broker_Id,Transporter_Id,Address_Id'
      };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/account/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNTS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAccounts = (commonMaster) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, company_id: auth.company?.id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      axios.get("/account/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNT, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAccountById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      const { auth } = getState();
      const params = { companyId: auth.company?.id };
      return axios.get(`/account/get/${id}`, { params }).then((response) => {
        dispatch({ type: ACCOUNT_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createAccount = (account, files = {}) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: ACCOUNT_REQUEST });

      const formData = new FormData();
      formData.append("data", JSON.stringify(account));
      formData.append("userId", auth.user?.id ?? "");
      formData.append("companyId", auth.company?.id ?? "");
      formData.append("customerId", auth?.user?.Customer_Id ?? "");

      // files: { [index]: File }
      Object.entries(files).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      return axios.post("/account/add", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        params: {
          userId: auth.user?.id,
          companyId: auth.company?.id,
          customerId: auth?.user?.Customer_Id,
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_ACCOUNT, payload: response.data });
          dispatch(addMasterInOption('accounts', response.data));
        } else {
          dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: "Account create failed." });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateAccount = (id, data, files = {}) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      const { auth } = getState();

      const formData = new FormData();
      formData.append("id", id);
      formData.append("data", JSON.stringify(data));
      formData.append("userId", auth.user?.id ?? "");
      formData.append("companyId", data.Company_Id || auth.company?.id || "");
      formData.append("customerId", auth?.user?.Customer_Id ?? "");

      Object.entries(files).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      return axios.put("/account/update", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        params: {
          userId: auth.user?.id,
          companyId: auth.company?.id,
          customerId: auth?.user?.Customer_Id,
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: UPDATE_ACCOUNT, payload: { id, data: response.data } });
          dispatch(updateMasterInOption('accounts', id, response.data));
        } else {
          dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: "Account update failed." });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteAccount = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      return axios.delete(`/account/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch(updateMasterInOption('accounts', id));
          dispatch({ type: DELETE_ACCOUNT, id: id });
          const include = ['id', 'Party_Name', 'Sech_Id', 'Broker_Id', 'Transporter_Id', 'Registration_Type', 'Party_Type'].join(',');
          const searchCols = ['Party_Name'].join(',');
          const { account: { page, pageSize, search, where } } = getState();
          dispatch(getAccountsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const gstDetailAccount = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      return axios.get("/e-invoice/get-gst-detail", {params: data}).then((response) => {
        dispatch({ type: ACCOUNT_REQUEST_SUCCESS });
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const gstDirectDetailAccount = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      return axios.get("/e-invoice/get-direct-gst-detail", {params: data}).then((response) => {
        dispatch({ type: ACCOUNT_REQUEST_SUCCESS });
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getOutstandingForPartyValidation = (partyId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id, partyId };
      
      const response = await axios.get("/account/get-os-for-party-validation", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDueDaysForPartyValidation = (partyId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id, partyId };
      
      const response = await axios.get("/account/get-due-days-for-party-validation", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesOutstandingByPartyOrGroupWise = (partyId, partyGroup) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id, partyId, partyGroup };

      return axios.get("/outstanding-report/getSalesReportByPartyOrGroup", { params })
      .then((response) => {
        console.log('<<response data--', response);
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const validateDeleteAccountAddress = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id, id: id };
    
      const response = await axios.get(`/account/validate-delete-account-address/${id}`, { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const updateTdsTurnOverFiftyLacStatus = (accountId, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      const params = {
        accountId,
        finyearId: fin?.id,
        companyId: auth.company?.id
      };
      return axios.put("/account/update-tds-turnover-fifty-lac-status", params,{ params }).then((response) => {
        if (response.data) {
          // dispatch({type: ACCOUNT_REQUEST_SUCCESS});
          dispatch({ type: UPDATE_ACCOUNT, payload: { accountId, data: response.data } });
          dispatch(updateMasterInOption('accounts', accountId, response.data));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({
          type: ACCOUNT_REQUEST_FAILURE,
          error: error.message
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: ACCOUNT_REQUEST_FAILURE,
        error: error.message
      });
      throw error;
    }
  };
};

export const updateStateOnUpdateAccountById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id };
      return axios.get(`/account/get/${id}`, { params }).then((response) => {
        dispatch({ type: UPDATE_ACCOUNT_IN_LIST, payload: { id, data: response.data } });
        dispatch({ type: UPDATE_ACCOUNT_IN_MASTER_OPTIONS, payload: { id, data: response.data } });
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateStateOnAddAccountById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = { companyId: auth.company?.id };
      return axios.get(`/account/get/${id}`, { params }).then((response) => {
        dispatch({ type: ADD_ACCOUNT_IN_LIST, payload: { data: response.data } });
        dispatch({ type: ADD_ACCOUNT_IN_MASTER_OPTIONS, payload: { data: response.data } });
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateStateOnDeleteAccountById = (id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      
      dispatch({ type: DELETE_ACCOUNT_IN_LIST, payload: { id } });
      dispatch({ type: DELETE_ACCOUNT_IN_MASTER_OPTIONS, payload: { id } });

    } catch (error) {
      console.error(error);
    }
  };
};